module.exports = __webpack_public_path__ + "img/文本图形.f821dcdb.svg";